import Header from "@components/Header.jsx";
import { useEffect, useState } from "react";

import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { Table, Typography } from "antd";
import { db } from "@/firebaseConfig";
import { useCurrentUserFromFirestore } from "../utils/useCurrentUserFromFirestore";

const OrderASOPage = () => {
  const { firestoreUser } = useCurrentUserFromFirestore();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { Paragraph } = Typography;

  useEffect(() => {
    if (!firestoreUser) return;

    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, "paymentCalendar"),
          where("userId", "==", firestoreUser.id),
          orderBy("createdAt", "desc"),
        );

        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setTransactions(data);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [firestoreUser]);

  const columns = [
    { title: "Amount", dataIndex: "amount", key: "amount" },
    { title: "Status", dataIndex: "status", key: "status" },
    {
      title: "Payment Date",
      dataIndex: "paymentDate",
      key: "paymentDate",
      render: (date) =>
        date ? new Date(date.seconds * 1000).toLocaleDateString() : "-",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) =>
        date ? new Date(date.seconds * 1000).toLocaleString() : "-",
    },
  ];

  return (
    <div className={`orderaso-page`}>
      <div className={`wrapper`}>
        <div className={`page page-app`}>
          <Header title="Payment calendar" />
          <div style={{ margin: "16px 0" }}>
            <strong>Account details:</strong>
            <Paragraph style={{ marginTop: 4, whiteSpace: "pre-line" }}>
              {firestoreUser?.accountDetails || "-"}
            </Paragraph>
          </div>

          <Table
            dataSource={transactions}
            columns={columns}
            rowKey="id"
            loading={loading}
            pagination={{ pageSize: 10 }}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderASOPage;
